module.exports = __webpack_public_path__ + "static/media/video-player.2c961ccc.png";